import React from 'react';
import Footer from './Footer';

function Layout({ children }) {
    return (
        <div className="layout-container">
            <main>{children}</main>
            <Footer />
        </div>
    );
}

export default Layout;